import React, { lazy, Suspense, useEffect } from "react";
import "./styles/App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
// Lazy‑load heavy sections to reduce initial bundle size
const About = lazy(() => import("./components/About"));
const Portfolio = lazy(() => import("./components/Portfolio"));
const Services = lazy(() => import("./components/Services"));
const Testimonials = lazy(() => import("./components/Testimonials"));
const Contact = lazy(() => import("./components/Contact"));
const Footer = lazy(() => import("./components/Footer"));
const FloatingContact = lazy(() => import("./components/FloatingContact"));
const DevPlan = lazy(() => import("./components/DevPlan"));
function App() {
  // Load third‑party chat scripts after the app mounts to avoid blocking the main thread
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://cdn.botpress.cloud/webchat/v3.4/inject.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src =
      "https://files.bpcontent.cloud/2025/11/23/14/20251123140319-TWU13472.js";
    script2.defer = true;
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <FloatingContact />

      <Suspense fallback={null}>
        <About />
        <Portfolio />
        <Services />
        <DevPlan />
        <Testimonials />
        <Contact />
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
